// React
import React from 'react';
// External
import { Container, Pagination } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Styles
import './styles.scss';
// Icons
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

/**
 * Custom navigator, works with url search/queryParams, if no query params are found the page is set to 1
 * @param {Object} props.className - Class to be applied to the button
 * @param {Object} props.lastPage - Last page to navigate to, this will limit the navigation to this page
 */
class CustomPagination extends React.Component {
    constructor(props) {
        super(props);
        this.className = 'custom-pagination ';
        this.className += props.className ? props.className : '';

        const pageFromUrl = new URLSearchParams(props.location.search).get('page');
        this.state = {
            activePage: parseInt(props.currentPage, 10) || (pageFromUrl ? parseInt(pageFromUrl, 10) : 1)
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.currentPage && nextProps.currentPage !== prevState.activePage) {
            return { activePage: parseInt(nextProps.currentPage, 10) };
        }
        return null;
    }

    setPagesAvailable = (activePage, lastPage) => {
        // The max number page to be displayed
        // When last page is less than the number of pages displayed
        const pagesDisplayedCount = 4;
        if (lastPage <= pagesDisplayedCount) {
            return [...Array(lastPage).keys()].map((key) => key + 1);
        }
        // Gets the number of available pages, the difference between the last page and the current page, inclusive (+1)
        const numOfAvailPages = lastPage - activePage + 1;
        if (numOfAvailPages >= pagesDisplayedCount) {
            return [activePage, activePage + 1, activePage + 2, activePage + 3];
        }
        // When the available pages is less than the pages displayed
        // Meaning that the pagination is in the last pages,
        // it should display from the 4th previous page before the last page
        const availPagesArr = [];
        const limit = lastPage - pagesDisplayedCount;
        for (let i = lastPage; i > limit; i -= 1) {
            availPagesArr.push(i);
        }
        return availPagesArr.reverse();
    }

    urlNavigatorConstructor(page) {
        let href = this.props.location.pathname;
        const additionalFilters = this.props.additionalFilters || {};
        const queryParams = new URLSearchParams(this.props.location.search);

        // Apply additionalFilters to queryParams
        Object.keys(additionalFilters).forEach((key) => {
            const value = additionalFilters[key];
            if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    queryParams.set(key, value.join(','));
                } else if (typeof value === 'object') {
                    queryParams.set(key, JSON.stringify(value));
                } else {
                    queryParams.set(key, value.toString().replace(/&/g, '*'));
                }
            } else {
                queryParams.delete(key);
            }
        });

        // Always set the page param
        queryParams.set('page', page);

        href += '?' + queryParams.toString();
        href += this.props.location.hash;
        return href;
    }

    render() {
        return (
            <Container className={this.className}>
                <Pagination>
                    <Pagination.Prev
                        href={this.urlNavigatorConstructor(Math.max(this.state.activePage - 1, 1))}
                        disabled={this.state.activePage === 1}
                        style={{ 'cursor': this.state.activePage === 1 ? 'not-allowed' : 'pointer' }}
                    >
                        <MdKeyboardArrowLeft />
                        Prev
                    </Pagination.Prev>
                    {
                        this.setPagesAvailable(this.state.activePage, this.props.lastPage).map((page) => (
                            <Pagination.Item
                                key={page}
                                className={this.state.activePage === page ? 'active' : 'page-item'}
                                href={this.urlNavigatorConstructor(page)}
                            >
                                {page}
                            </Pagination.Item>
                        ))
                    }
                    <Pagination.Next
                        href={this.urlNavigatorConstructor(this.state.activePage + 1)}
                        disabled={this.state.activePage === this.props.lastPage}
                        style={{ 'cursor': this.state.activePage === this.props.lastPage ? 'not-allowed' : 'pointer' }}
                    >
                        Next
                        <MdKeyboardArrowRight />
                    </Pagination.Next>
                </Pagination>
            </Container>
        );
    }
}

export default withRouter(CustomPagination);
